<template>
  <div class="container">
    <p>{{ title }}</p>
    <div class="shift-btns">
      <font-awesome-icon
        class="shift-btn"
        :icon="['fas', 'arrow-up']"
        style="transform: rotate(-90deg)"
        @click="shift(-1)"
      />
      <font-awesome-icon
        class="shift-btn"
        :icon="['fas', 'arrow-up']"
        style="transform: rotate(90deg)"
        @click="shift(1)"
      />
    </div>
    <div class="col-container">
        <p class="col" v-for="(val, index) in values" :key="index" @click="selected = index" :style="{backgroundColor: selected == index ? '#dedede' : ''}">
            {{display ? val[display] : val}}
        </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    display: {
      required: false,
      value: String,
    },

    values: {
      required: true,
      value: Array,
    },

    title: {
      required: true,
      value: String,
    },
  },
  data(){
      return{
          selected:{}
      }
  },
  methods: {
    shift(shiftAmnt) {
      this.values.splice(this.selected + shiftAmnt, 0, this.values.splice(this.selected, 1)[0]);
      this.selected += shiftAmnt
      this.$emit("order-changed", this.values)
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
}

.shift-btns{
    width: 30%;
    display:flex;
    justify-content: space-between;
    align-items: center;
}

.shift-btn{
    border: 1px solid rgb(134, 134, 134);
    padding:5px;
    font-size: 20px;
    cursor:pointer;
    margin-top:5px;
}

.shift-btn:hover{
    background-color: #dedede;
}

.col-container{
    margin-top:20px;
    width:100%;
    max-width:500px;
    display:flex;
    flex-wrap:wrap;
    justify-content: space-evenly;
    font-size: 11px
}

.col{
    border: 1px solid #dedede;
    padding:5px;
    margin: 5px 0;
    cursor:pointer
}

.col:hover{
    background-color: #dedede;
}
</style>